import React, { useEffect, useState } from 'react';
import { Table, Row, Col, message, Button } from 'antd';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { fetchRateCard, updateRateCard, resetUpdateRateCard } from 'appRedux/actions/RateCard';
import Widget from 'components/Widget';
import { EditableCell, EditableFormRow } from './EditableCell';
import Columns from './Columns';
import convertData from 'firebase/utils/convertData';

const DataDefinePriceByDataLevel = ({
  currentUser,
  fetchRateCard,
  updateRateCard,
  rateCardList,
  loading,
  updating,
  payload,
  resetUpdateRateCard,
}) => {
  const [dataSource, setDataSource] = useState([]);
  const [disableSubmit, setDisableSubmit] = useState(false);

  const components = {
    body: {
      row: EditableFormRow,
      cell: EditableCell,
    },
  };

  const isNotAllowSubmit = loading || disableSubmit;

  const columns = Columns().map(col => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleUpdateRow,
        handleError: handleError,
      }),
    };
  });

  const handleUpdateRow = row => {
    const newData = [...dataSource];
    const index = newData.findIndex(item => row.index === item.index);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
      level1: row.level1 * 1,
      level2: row.level2 * 1,
      level3: row.level3 * 1,
      rate_card: row.rate_card * 1,
    });
    setDataSource(newData);
  };

  const handleSave = e => {
    e.preventDefault();
    dataSource.forEach((_, i) => { dataSource[i].created_at = moment().unix(); dataSource[i].created_by = currentUser; } );
    message.loading({ content: 'Đang cập nhật dữ liệu...', key: 'updatable' });
    updateRateCard(dataSource);
  };

  const handleError = (isDisabled) => {
    setDisableSubmit(isDisabled);
  };

  useEffect(() => {
    fetchRateCard();
  }, [fetchRateCard]);

  useEffect(() => {
    if (payload.message) {
      message.success({ content: payload.message, key: 'updatable', duration: 2  });
      resetUpdateRateCard();
    }
  }, [payload, resetUpdateRateCard]);

  useEffect(() => {
    if (!loading && !isEmpty(rateCardList)) {
      const convertedData = isEmpty(rateCardList) ? [] : convertData(rateCardList, true);
      setDataSource(convertedData);
    }
  }, [loading, rateCardList]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Data Level</h2>}
          >
            <Table
              loading={loading}
              pagination={false}
              bordered
              size='small'
              components={components}
              rowClassName={() => 'editable-row'}
              dataSource={dataSource}
              columns={columns}
            />
            <div className='save-segment'>
              <Button disabled={isNotAllowSubmit} loading={updating} icon='vertical-align-bottom' size='large' onClick={handleSave} type="primary">
                Save
              </Button>
            </div>
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ rateCard, auth }) => {
  const { currentUser } = auth;
  const { data: rateCardList, loading, updating, payload } = rateCard;
  return { currentUser, rateCardList, loading, updating, payload };
};

export default connect(
  mapStateToProps,
  {
    fetchRateCard,
    updateRateCard,
    resetUpdateRateCard,
  },
)(DataDefinePriceByDataLevel);
